export default __webpack_public_path__ + "static/home_service_1-f7101aec3a3fbb96fccb2754e4ac2ce0.jpg";